module.exports = __webpack_public_path__ + "static/2-d4cac589520b5b0a6685b0da947d0568.jpg";